import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { SurveyService } from '../services/survey.service';
import { SurveyProvidersModule } from '../survey-providers.module';

@Injectable({
    providedIn: SurveyProvidersModule,
})
export abstract class SurveyActivator {
    constructor(
        private readonly surveyService: SurveyService,
        private readonly router: Router
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.surveyService.beforeSurveyStart(route).pipe(take(1), switchMap(this.continueOrGoToDashboard));
    }

    private continueOrGoToDashboard = (canActivate: boolean): Observable<boolean | UrlTree> =>
        iif(() => canActivate, of(true), of(this.router.createUrlTree([])));
}
